var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortalLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4399 15.3704C17.2499 15.3704 17.0599 15.3004 16.9099 15.1504C16.6199 14.8604 16.6199 14.3804 16.9099 14.0904L18.9399 12.0604L16.9099 10.0304C16.6199 9.74043 16.6199 9.26043 16.9099 8.97043C17.1999 8.68043 17.6799 8.68043 17.9699 8.97043L20.5299 11.5304C20.8199 11.8204 20.8199 12.3004 20.5299 12.5904L17.9699 15.1504C17.8199 15.3004 17.6299 15.3704 17.4399 15.3704Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9298 12.8096H9.75977C9.34977 12.8096 9.00977 12.4696 9.00977 12.0596C9.00977 11.6496 9.34977 11.3096 9.75977 11.3096H19.9298C20.3398 11.3096 20.6798 11.6496 20.6798 12.0596C20.6798 12.4696 20.3398 12.8096 19.9298 12.8096Z",
    fill: "#292929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7598 20.75C6.60977 20.75 3.00977 17.15 3.00977 12C3.00977 6.85 6.60977 3.25 11.7598 3.25C12.1698 3.25 12.5098 3.59 12.5098 4C12.5098 4.41 12.1698 4.75 11.7598 4.75C7.48977 4.75 4.50977 7.73 4.50977 12C4.50977 16.27 7.48977 19.25 11.7598 19.25C12.1698 19.25 12.5098 19.59 12.5098 20C12.5098 20.41 12.1698 20.75 11.7598 20.75Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalLogoutIcon);
export default __webpack_public_path__ + "static/media/portal-logout-icon.86dd85d03c5e34d24aef2a76db1515bf.svg";
export { ForwardRef as ReactComponent };